export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16A8 8 0 108 0a8 8 0 000 16zM8 3a1 1 0 000 2 3 3 0 012.987 2.72 1 1 0 00-1.061 1.618l1.006 1.111a1 1 0 001.247.191l1.327-.777A1 1 0 0013 8a5 5 0 00-5-5zM5.068 5.55a1 1 0 00-1.247-.19l-1.327.777A1 1 0 003 8a5 5 0 005 5 1 1 0 100-2 3 3 0 01-2.987-2.72 1 1 0 001.062-1.618L5.068 5.551z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};